/* eslint-disable */
import React from "react";
import { getPropertyChats } from "../../../actions/appExpandedActions/properties";
import { connect } from "react-redux";
import DataTable from "../DataTable";
import { tablePresets } from "../DataTable/tablePresets";

const ChatTodos = ({ getPropertyChats, propertyChats, period }) => (
  <DataTable
    {...tablePresets.chatTodos}
    data={propertyChats}
    fetchData={getPropertyChats}
    period={period}
  />
);

const mapStateToProps = (state) => ({
  propertyChats: state.appProperties.propertyChats
});

const mapDispatchToProps = (dispatch) => ({
  getPropertyChats: (payload) => dispatch(getPropertyChats(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatTodos); 